import { AvailabilityDto } from "@insite/client-framework/Types/ApiModels";

export enum ElkAvailabilitySubMessageType {
    None = 0,
    PreOrder = 1,
    BackOrder = 2,
}

export interface ElkAvailabilityDto extends AvailabilityDto {
    subMessageType: ElkAvailabilitySubMessageType;
}
